import {
  Box,
  Divider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import IconButton from "./IconButton";
import JobDataModal from "../modal/JobDataModal";

const JobDetails = ({
  name,
  jobId,
  description,
  dataSource,
  dataDestination,
  config,
  // taskTimeOut,
  // jobTimeOut,
  templateId,
  appId,
  partitionerId,
  assemblerId,
  dataSourceData,
  dataDestinationData,
  appParams,
  partitionerParameter,
  assemblerParameter,
}: {
  name: string;
  jobId: string;
  description: string;
  dataSource: string;
  dataDestination: string;
  config: any;
  // taskTimeOut: string;
  // jobTimeOut: string;
  templateId: string;
  appId: string;
  partitionerId: string;
  assemblerId: string;
  dataSourceData: any;
  dataDestinationData: any;
  appParams: any;
  partitionerParameter: any;
  assemblerParameter: any;
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("");
  const [modalData, setModalData] = useState({});
  const handleCloseModal = () => {
    setOpenModal(false);
    setTitle("");
    setModalData({});
  };
  const handleOpenDataSource = () => {
    setOpenModal(true);
    setTitle("Data Source");
    setModalData(dataSourceData);
  };
  const handleDataDestination = () => {
    setOpenModal(true);
    setTitle("Data Destination");
    setModalData(dataDestinationData);
  };
  const handleAppParameter = () => {
    setOpenModal(true);
    setTitle("App Parameter");
    setModalData(appParams);
  };
  const handlePartitionerParameter = () => {
    setOpenModal(true);
    setTitle("Partitioner Parameter");
    setModalData(partitionerParameter);
  };
  const handleAssemblerParameter = () => {
    setOpenModal(true);
    setTitle("Assembler Parameter");
    setModalData(assemblerParameter);
  };
  return (
    <Box
      sx={{
        borderLeft: "1px solid #B027CE",
        pl: 1,
        borderWidth: "2px",
      }}
    >
      <Typography color={"#470056"}>Job Details</Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          columnGap: 2,
          mt: 1,
        }}
      >
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "12px",
            color: "#414040",
          }}
        >
          {name}
        </Typography>
        <Typography
          sx={{
            fontWeight: 500,
            fontStyle: "italic",
            fontSize: "12px",
            color: "#7A7A7A",
          }}
        >
          {jobId}
        </Typography>
      </Box>
      <Divider />
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 500,
          color: "#414040",
        }}
      >
        {description}
      </Typography>

      <Table sx={{ width: "100%", mt: 1 }}>
        <TableHead
          sx={{
            background: "#F9F9F9",
          }}
        >
          <TableRow>
            <TableCell
              sx={{ fontWeight: 600, fontSize: "12px" }}
              className="table-header-left-cell"
              align="left"
            >
              Data Source
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: "12px" }} align="left">
              Data Destination
            </TableCell>
            <TableCell
              sx={{ fontWeight: 600, fontSize: "12px" }}
              className="table-header-right-cell"
              align="left"
            >
              Config
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow
            sx={{ "&:first-child td, &:first-child th": { paddingTop: 2 } }}
          >
            <TableCell
              sx={{
                border: "none",
              }}
            >
              {dataSource && (
                <IconButton label={dataSource} onClick={handleOpenDataSource} />
              )}
            </TableCell>
            <TableCell
              sx={{
                border: "none",
              }}
            >
              {dataDestination && (
                <IconButton
                  label={dataDestination}
                  onClick={handleDataDestination}
                />
              )}
            </TableCell>
            <TableCell
              sx={{
                border: "none",
              }}
            >
              {config
                ? Object.entries(config).map(([key, value]) => (
                    <Stack direction={"row"} key={key}>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#414040",
                          fontWeight: 500,
                        }}
                      >
                        {key}:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#414040",
                          fontWeight: 500,
                          ml: 1,
                        }}
                      >
                        {String(value)}
                      </Typography>
                    </Stack>
                  ))
                : "-"}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table sx={{ width: "100%", mt: 4, border: "none" }}>
        <TableHead
          sx={{
            background: "#F9F9F9",
          }}
        >
          <TableRow>
            <TableCell
              sx={{ fontWeight: 600, fontSize: "12px", border: "none" }}
              className="table-header-left-cell"
              align="left"
            >
              Template
            </TableCell>
            <TableCell
              sx={{ fontWeight: 600, fontSize: "12px", border: "none" }}
              align="left"
            >
              App
            </TableCell>
            <TableCell
              sx={{ fontWeight: 600, fontSize: "12px", border: "none" }}
              align="left"
            >
              Partitioner
            </TableCell>
            <TableCell
              sx={{ fontWeight: 600, fontSize: "12px", border: "none" }}
              className="table-header-right-cell"
              align="left"
            >
              Assembler
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow
            sx={{ "&:first-child td, &:first-child th": { paddingTop: 3 } }}
          >
            <TableCell
              sx={{
                border: "none",
              }}
            >
              {templateId && (
                <IconButton label={templateId} enableIcon={false} />
              )}
            </TableCell>
            <TableCell
              sx={{
                border: "none",
              }}
            >
              <Stack rowGap={1}>
                {appId && <IconButton label={appId} enableIcon={false} />}
                <IconButton label="app params" onClick={handleAppParameter} />
              </Stack>
            </TableCell>
            <TableCell
              sx={{
                border: "none",
              }}
            >
              <Stack rowGap={1}>
                {partitionerId && (
                  <IconButton label={partitionerId} enableIcon={false} />
                )}
                <IconButton
                  label="partitioner params"
                  onClick={handlePartitionerParameter}
                />
              </Stack>
            </TableCell>
            <TableCell
              sx={{
                border: "none",
              }}
            >
              <Stack rowGap={1}>
                <IconButton label={assemblerId} enableIcon={false} />
                <IconButton
                  label="assembler params"
                  onClick={handleAssemblerParameter}
                />
              </Stack>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <JobDataModal
        openModal={openModal}
        handleClose={handleCloseModal}
        title={title}
      >
        {modalData}
      </JobDataModal>
    </Box>
  );
};

export default JobDetails;
